





























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { JobAlert } from '../models/jobs/jobalert';
import { JobFilter } from '@/models/jobs/jobfilter';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'JobAlertUI',
  components: {},
})
export default class JobAlertUI extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private recsPerPage: number = 10;
  private jobAlert: JobAlert = new JobAlert();
  private industry: number = 0;
  private jobSkill: number = 0;
  private candidatePlacementType: string = '';
  private confirmationCheck: boolean = false;

  closeWindow() {
    this.$modal.hide('job-alert-modal');
  }

  showWindow() {
    this.setSearchDetails();
    this.$modal.show('job-alert-modal');
  }

  ///////////////////////////////////////////////

  reload() {
    const jlp = vxm.jobs.JobListParams;
    jlp.resultSize = this.recsPerPage;
    vxm.jobs.reloadJobs(jlp);
  }

  ///////////////////////////////////////////////

  getUserAuthenticationStatus() {
    if (vxm.users.isLoggedIn) {
      this.jobAlert.email = vxm.users.myUserProfile.email;
      this.jobAlert.fullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
    }
  }

  ///////////////////////////////////////////////

  setSearchDetails() {
    console.log('Test', vxm.jobs.JobListParams);
    this.jobAlert.textCriteria = vxm.jobs.JobListParams.keywords;
    this.jobAlert.jobConfigDetails = JSON.stringify(vxm.jobs.JobListParams);
    this.jobAlert.location = vxm.jobs.JobListParams.location;
    this.jobAlert.companyCode = vxm.jobs.JobListParams.filter.companyCode;
    if (
      vxm.jobs.JobListParams.filter.candidatePlacementTypes &&
      vxm.jobs.JobListParams.filter.candidatePlacementTypes.length > 0
    ) {
      this.candidatePlacementType =
        vxm.jobs.JobListParams.filter.candidatePlacementTypes[0];
    } else {
      this.candidatePlacementType = '';
    }
    if (
      vxm.jobs.JobListParams.filter.industryTypes &&
      vxm.jobs.JobListParams.filter.industryTypes.length > 0
    ) {
      this.industry = vxm.jobs.JobListParams.filter.industryTypes[0];
    } else {
      this.industry = 0;
    }
    if (
      vxm.jobs.JobListParams.filter.skillTypes &&
      vxm.jobs.JobListParams.filter.skillTypes.length > 0
    ) {
      this.jobSkill = vxm.jobs.JobListParams.filter.skillTypes[0];
    } else {
      this.jobSkill = 0;
    }
    this.getUserAuthenticationStatus();
  }

  //////////////////////////////////////////////////

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get candidatePlacementTypes(): JobFilter[] {
    return vxm.jobs.jfWrapper.candidatePlacementTypes;
  }

  get sortingOptions(): JobFilter[] {
    return vxm.jobs.jfWrapper.sortingOptions;
  }

  get industryVerticals(): JobFilter[] {
    return vxm.jobs.jfWrapper.industryVerticals;
  }

  get datePosted(): JobFilter[] {
    return vxm.jobs.jfWrapper.datePosted;
  }

  get jobSkills(): JobFilter[] {
    return vxm.jobs.jfWrapper.jobSkills;
  }

  //////////////////////////////////////////////////

  validateJobAlert(): boolean {
    if (
      this.confirmationCheck === false ||
      !this.jobAlert.email ||
      !this.jobAlert.fullName ||
      !this.jobAlert.name ||
      !this.jobAlert.textCriteria
    ) {
      this.$wlToastr(
        'error',
        this.$t(this.errorString),
        'Alert Name, Full Name, E-mail, Criteria, and Confirmation Check required!',
      );
      return false;
    } else {
      return true;
    }
  }

  //////////////////////////////////////////////////

  saveJobAlert() {
    if (this.validateJobAlert()) {
      vxm.jobs.createJobAlert(this.jobAlert).then((res) => {
        console.log('Job Alert Respons', res);
        if (res === true) {
          this.$wlToastr(
            'success',
            this.$t(this.successString),
            this.getJobAlertSuccessMessage(),
          );
        }
      });
    }
  }

  getJobAlertSuccessMessage() {
    if (vxm.users.isLoggedIn) {
      return this.$t('jobalert-created-success-message').toString();
    }
    return this.$t('jobalert-created-anon-success-message').toString();
  }

  //////////////////////////////////////////////////

  mounted() {
    this.setSearchDetails();
    if (vxm.users.isLoggedIn) {
      this.recsPerPage = vxm.jobs.JobListParams.resultSize;
    }
  }
}
